/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Photos_HintInputs */

const cs_projects_photos_hint = /** @type {(inputs: Projects_Photos_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotky se exportují na Sreality spolu s projektem. Nahrajte JPEG, PNG nebo WebP.`)
};

const en_projects_photos_hint = /** @type {(inputs: Projects_Photos_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos exported to Sreality with the project. Upload JPEG, PNG, or WebP.`)
};

/**
* | output |
* | --- |
* | "Photos exported to Sreality with the project. Upload JPEG, PNG, or WebP." |
*
* @param {Projects_Photos_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_photos_hint = /** @type {((inputs?: Projects_Photos_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Photos_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_photos_hint(inputs)
	return cs_projects_photos_hint(inputs)
});